const nameList = [
  "Time",
  "Past",
  "Future",
  "Dev",
  "Fly",
  "Flying",
  "Soar",
  "Soaring",
  "Power",
  "Falling",
  "Fall",
  "Jump",
  "Cliff",
  "Mountain",
  "Rend",
  "Red",
  "Blue",
  "Green",
  "Yellow",
  "Gold",
  "Demon",
  "Demonic",
  "Panda",
  "Cat",
  "Kitty",
  "Kitten",
  "Zero",
  "Memory",
  "Trooper",
  "XX",
  "Bandit",
  "Fear",
  "Light",
  "Glow",
  "Tread",
  "Deep",
  "Deeper",
  "Deepest",
  "Mine",
  "Your",
  "Worst",
  "Enemy",
  "Hostile",
  "Force",
  "Video",
  "Game",
  "Donkey",
  "Mule",
  "Colt",
  "Cult",
  "Cultist",
  "Magnum",
  "Gun",
  "Assault",
  "Recon",
  "Trap",
  "Trapper",
  "Redeem",
  "Code",
  "Script",
  "Writer",
  "Near",
  "Close",
  "Open",
  "Cube",
  "Circle",
  "Geo",
  "Genome",
  "Germ",
  "Spaz",
  "Shot",
  "Echo",
  "Beta",
  "Alpha",
  "Gamma",
  "Omega",
  "Seal",
  "Squid",
  "Money",
  "Cash",
  "Lord",
  "King",
  "Duke",
  "Rest",
  "Fire",
  "Flame",
  "Morrow",
  "Break",
  "Breaker",
  "Numb",
  "Ice",
  "Cold",
  "Rotten",
  "Sick",
  "Sickly",
  "Janitor",
  "Camel",
  "Rooster",
  "Sand",
  "Desert",
  "Dessert",
  "Hurdle",
  "Racer",
  "Eraser",
  "Erase",
  "Big",
  "Small",
  "Short",
  "Tall",
  "Sith",
  "Bounty",
  "Hunter",
  "Cracked",
  "Broken",
  "Sad",
  "Happy",
  "Joy",
  "Joyful",
  "Crimson",
  "Destiny",
  "Deceit",
  "Lies",
  "Lie",
  "Honest",
  "Destined",
  "Bloxxer",
  "Hawk",
  "Eagle",
  "Hawker",
  "Walker",
  "Zombie",
  "Sarge",
  "Capt",
  "Captain",
  "Punch",
  "One",
  "Two",
  "Uno",
  "Slice",
  "Slash",
  "Melt",
  "Melted",
  "Melting",
  "Fell",
  "Wolf",
  "Hound",
  "Legacy",
  "Sharp",
  "Dead",
  "Mew",
  "Chuckle",
  "Bubba",
  "Bubble",
  "Sandwich",
  "Smasher",
  "Extreme",
  "Multi",
  "Universe",
  "Ultimate",
  "Death",
  "Ready",
  "Monkey",
  "Elevator",
  "Wrench",
  "Grease",
  "Head",
  "Theme",
  "Grand",
  "Cool",
  "Kid",
  "Boy",
  "Girl",
  "Vortex",
  "Paradox",
];
export function GenerateRandomName() {
  return nameList[Math.floor(Math.random() * nameList.length)];
}

const testData = [
  {
    text: "This is some awesome thinking!",
  },
  {
    text: "What terrific math skills you’re showing!",
  },
  {
    text: "You are an amazing writer!",
  },
  {
    text: "Wow! You have improved so much!",
  },
  {
    text: "Nice idea!",
  },
  {
    text: "You are showing excellent understanding!",
  },
  {
    text: "This is clear, concise, and complete!",
  },
  {
    text: "What a powerful argument!",
  },
  {
    text: "I knew you could do it!",
  },
  {
    text: "Wonderful ideas!",
  },
  {
    text: "It was a pleasure to grade this!",
  },
  {
    text: "Keep up the incredible work!",
  },
  {
    text: "My goodness, how impressive!",
  },
  {
    text: "You’re showing inventive ideas!",
  },
  {
    text: "You’ve shown so much growth!",
  },
  {
    text: "Interesting thoughts!",
  },
  {
    text: "I love your neat work!",
  },
  {
    text: "Doesn’t it feel good to do such great work?",
  },
  {
    text: "First-rate work!",
  },
  {
    text: "This is fascinating information!",
  },
  {
    text: "You inspire me!",
  },
  {
    text: "This is right on target!",
  },
  {
    text: "What an astounding observation!",
  },
  {
    text: "This is very well thought out!",
  },
  {
    text: "I can tell you’ve been practicing!",
  },
  {
    text: "You’ve come a long way!",
  },
  {
    text: "I can tell you’ve been paying attention!",
  },
  {
    text: "Reading this made my day!",
  },
  {
    text: "This is very perceptive!",
  },
  {
    text: "What an accomplishment!",
  },
];

export const randomTextGenerator = () => {
  return testData[Math.floor(Math.random() * testData.length)].text;
};
